/**
 * Textos estáticos de referencia — HU 8300 / Figma landing PN (node 152:53620).
 * Hero: fallback si el banner `Bienvenido` no responde (ver `HomeHeroService`, plan B.2).
 */
export const HOME_CONTENT_MOCK = {
  header: {
    nav: {
      comoFunciona: 'Cómo funciona',
      aliados: 'Aliados',
      creaTuCuenta: 'Crea tu cuenta',
    },
    iniciarSesion: 'Iniciar sesión',
  },
  hero: {
    eyebrowHtml:
      '<span class="home-v2__hero-eyebrow-light">UNA SOLICITUD. MULTIPLES OFERTAS.</span> <span class="home-v2__hero-eyebrow-bold">TÚ ELIGES.</span>',
    titleHtml:
      '<span class="home-v2__hero-title-line">Financiar tu negocio</span><span class="home-v2__hero-title-line home-v2__hero-title-line--accent">a tu medida</span>',
    subtitleHtml:
      'Conectamos tu empresa con <strong class="home-v2__hero-subtitle-highlight">más de 25 entidades financieros</strong> en un solo lugar.',
    ctaNatural: 'Soy Persona Natural',
    ctaJuridica: 'Soy Persona Jurídica',
  },
  valor: {
    eyebrow: 'NEOCRÉDITO',
    titleHtml:
      'Impulsamos el negocio <span class="home-valor__title-accent">que quieres ser</span>',
    introHtml:
      '<p>No prestamos el dinero, te conectamos con quienes lo hacen. Con el respaldo de Bancóldex, conectamos tu negocio con más de 25 entidades financieras en un solo lugar.</p><p>Tú aplicas una vez y nosotros negociamos las mejores ofertas de crédito <em class="home-valor__copy-accent">por ti.</em></p>',
    beneficios: [
      {
        title: 'Ahorro de tiempo',
        description:
          'Olvida las filas y las múltiples solicitudes; los bancos compiten por tu negocio.',
        iconSrc: 'assets/img/Home/valor/icon-benefit-time.svg',
      },
      {
        title: 'Mejores condiciones',
        description: 'Aumentamos tus posibilidades de obtener tasas más favorables.',
        iconSrc: 'assets/img/Home/valor/icon-benefit-conditions.svg',
      },
      {
        title: 'Simplicidad total',
        description:
          'Una sola carga de documentos te abre las puertas a múltiples opciones de crédito.',
        iconSrc: 'assets/img/Home/valor/icon-benefit-simplicity.svg',
      },
    ],
  },
  pasos: {
    eyebrow: 'SIN LETRAS CHIQUITAS',
    title: '4 pasos para obtener tu crédito ideal',
    titleHtml:
      '4 pasos para obtener <span class="home-pasos__title-accent">tu crédito ideal</span>',
    items: [
      {
        title: 'Crea tu perfil en segundos',
        description:
          'Solo necesitamos tus datos básicos para abrirte las puertas de la plataforma.',
      },
      {
        title: 'Cuéntanos sobre ti y tu empresa',
        description:
          'Diligencia la información de tu negocio una sola vez. Estos datos nos sirven para presentarte ante los bancos como el candidato ideal.',
      },
      {
        title: 'Define tu necesidad',
        description:
          'Dinos cuánto dinero necesitas y para qué lo vas a usar. Son datos cortos que nos permiten filtrar las mejores ofertas para ti.',
      },
      {
        title: 'Compara y elige tu mejor opción',
        description:
          'Conectamos tu solicitud con +20 entidades financieras para que tú compares y elijas.',
      },
    ],
  },
  aliados: {
    eyebrow: 'ALIADOS FINANCIEROS',
    titleHtml:
      'Conoce a quienes <span class="home-aliados__title-accent">financiarán tu negocio</span>',
    description:
      'Accede a una red de más de 25 aliados financieros listos para respaldarte. Nos encargamos de gestionar tu solicitud ante todos ellos para que tú solo tengas que comparar y elegir la mejor opción.',
    joinPrompt: '¿Quieres ser aliado financiero?',
    uniteLabel: 'Únete a neocrédito',
    /** Fallback sin URL: el CTA no navega hasta parametrizar en admin. */
    uniteUrl: '',
  },
  registro: {
    title: 'Y conéctate con nuestros aliados financieros',
    submitLabel: 'Crear cuenta',
  },
  metricas: [
    { value: 'Miles', label: 'de negocios ya confían en neocrédito' },
    { value: 'Bancóldex', label: 'asegura y respalda el proceso' },
    { value: '+800', label: 'municipios cubiertos en Colombia' },
    { value: '+ $10.000 M', label: 'gestionados con +20 aliados financieros' },
  ],
  testimonios: {
    eyebrow: 'Historias reales',
    title: 'Testimonios de emprendedores como tú',
    items: [
      {
        name: 'Luz Mercado',
        role: 'Propietaria - Spa Nails Luz',
        quote:
          '\u201CNos metimos en la plataforma y nos respondieron inmediatamente\u201D',
        image: 'assets/img/Home/testimonios/testimonio-luz.png',
        imageAlt: 'Luz Mercado en su sal\u00f3n de belleza',
      },
      {
        name: 'Rafael Arias',
        role: 'Propietario - Flores by Rafa',
        quote:
          '\u201CFue asunto de inscribirme y a los dos d\u00edas ya ten\u00eda 3 ofertas de cr\u00e9dito\u201D',
        image: 'assets/img/Home/testimonios/testimonio-flores.png',
        imageAlt: 'Rafael Arias en su negocio de flores',
      },
      {
        name: 'Siervo C\u00e1rdenas',
        role: 'Propietario - Santa M\u00f3nica S.A.S',
        quote:
          '\u201CSe pudo comprar lo que necesitabamos. Llen\u00f3 la expectativa, fueron muy oportunos\u201D',
        image: 'assets/img/Home/testimonios/testimonio-Siervo-Cardenas.png',
        imageAlt: 'Siervo C\u00e1rdenas, propietario de Santa M\u00f3nica S.A.S',
      },
      {
        name: 'Wilfredo Tibaduiza',
        role: 'Gerente - JF Ferreteria',
        quote:
          '\u201CMe tocaba pedirle al t\u00edo, al familiar, pr\u00e9steme para pagar unas cosas. Ahora ya tengo un dinero para eso\u201D',
        image: 'assets/img/Home/testimonios/testimonio-ferreteria.png',
        imageAlt: 'Wilfredo Tibaduiza en su ferreter\u00eda',
      },
    ],
  },
  segmentacion: {
    title: '¿Es neocrédito para mí?',
    natural: {
      title: 'Si eres persona natural independiente',
      cta: 'Hacer crecer mi negocio',
    },
    juridica: {
      title: 'Si eres una empresa o persona jurídica',
      cta: 'Potenciar mi empresa',
    },
  },
  /** Fallback sección «¿Es neocrédito para mí?» (`QueEsNeocredito`). */
  paraMi: {
    sectionTitle:
      '¿Es neocrédito <span class="home-para-mi__title-accent">para mí?</span>',
    natural: {
      title: 'Si eres persona natural o independiente:',
      description:
        'Para quienes están construyendo su negocio y buscan capital formal, sin enredos ni procesos complicados.',
      pasos: [
        'Requisitos flexibles para negocios en etapa de crecimiento.',
        'Te acompañamos para que tu perfil financiero sea atractivo para los bancos.',
        'Acceso a crédito formal para dejar atrás los préstamos informales.',
      ],
      buttonLabel: 'Hacer crecer mi negocio',
      buttonUrl: '/home?perfil=natural#home-crea-cuenta',
    },
    juridica: {
      title: 'Si eres una empresa o persona jurídica:',
      description:
        'Para negocios establecidos que necesitan capital estratégico para crecer: comprar inventario, expandirse o mejorar el flujo de caja.',
      pasos: [
        'Compara ofertas de múltiples bancos en un solo lugar.',
        'Negociamos tasas competitivas gracias al respaldo de Bancóldex',
        'Proceso digital optimizado para que no pierdas tiempo en trámites.',
      ],
      buttonLabel: 'Potenciar mi empresa',
      buttonUrl: '/home?perfil=juridica#home-crea-cuenta',
    },
  },
  faq: {
    eyebrow: 'PREGUNTAS FRECUENTES',
    title: 'Resolvemos <span class="home-faq__title-accent">tus dudas</span>',
    items: [
      {
        pregunta: '¿neocrédito me presta el dinero directamente?',
        respuesta:
          'No, neocrédito es la plataforma que conecta tu solicitud con +25 entidades financieras aliadas. Tú eliges la oferta que mejor se ajuste a tu negocio y el desembolso lo hace directamente el banco que selecciones.',
      },
      {
        pregunta: '¿Cuanto cuesta usar neocrédito?',
        respuesta:
          'Crear tu cuenta y recibir ofertas es totalmente gratis. Solo cuando aceptas un crédito asumes los costos definidos por la entidad financiera elegida.',
      },
      {
        pregunta: '¿Qué pasa después de enviar mi solicitud?',
        respuesta:
          'Compartimos tu información de forma segura con los aliados financieros. Te informamos sobre los avances clave del proceso.',
      },
      {
        pregunta: '¿Qué documentos necesito?',
        respuesta:
          'Documento de identidad, información básica de tu negocio y soportes financieros recientes. La plataforma te guía paso a paso según el perfil que elijas.',
      },
      {
        pregunta: '¿Mis datos están seguros?',
        respuesta:
          'Sí. Operamos bajo los estándares de seguridad de Bancóldex y cumplimos con la Ley 1581 de Protección de Datos en Colombia.',
      },
    ],
  },
  ctaFinal: {
    eyebrow: 'UNA SOLICITUD. MÚLTIPLES OPCIONES. TÚ ELIGES.',
    title: 'Hagamos realidad la visión que tienes para tu negocio',
    description:
      'Tú pones la meta, nosotros te ayudamos a encontrar el camino financiero para llegar a ella.',
    buttonLabel: 'Iniciar impulso <em>ahora</em>',
    buttonUrl: '/home?perfil=natural#home-crea-cuenta',
  },
  anchors: {
    comoFunciona: 'home-como-funciona',
    aliados: 'home-aliados',
    /** Nav «Crea tu cuenta» (Figma): sección registro Fase 6; no el hero (#home-seleccion-persona). */
    creaCuenta: 'home-crea-cuenta',
  },
} as const;

export type HomeContentMock = typeof HOME_CONTENT_MOCK;
